<app-form-input [parentForm]="parentForm" [disabled]="disabled"
	[value]="fnSimpleAttribution.natureMarche.criteresAttrib" [label]="step2.criteresAttrib" [type]="'text'"
	[rule]="'minSize_5|maxSize_2000'" [name]="getUidNatureMarche() + '_SepAtt_criteresAttrib'">
</app-form-input>
